import React from "react";
import Navbar from './Navbar'; 
import AboutWhat from './AboutWhat'; 
import ConsultationSection from './ConsultationSection';
import FooterSection from './FooterSection';
import ThermographyBenefits from './ThermographyBenefits';
import "./WhatBanner.css"; // Import custom styles
import bannerImage from "../assets/img/service_banner.png"; // Import your image path

const WhatBanner = () => {
  return (
    <>
      <Navbar />
      
      {/* Main content area with background color */}
      <main className="main-content">
        <section
          className="whatbanner-container d-flex justify-content-center align-items-center text-center position-relative"
          style={{
            backgroundImage: `url(${bannerImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            height: '500px',  // You can adjust the height here as needed
            color: '#fff',  // Set the text color to white for better contrast
          }}
        >
          <div className="overlay-text position-absolute top-50 start-50 translate-middle">
            <h1 className="morrestact-font text-black text-start">Understanding Breast <br/>Infrared The Future <br/> of Early Detection</h1>
            <p className="popins-font text-black text-start">
              A cutting-edge, non-invasive screening method using infrared imaging <br/> to detect early changes in breast tissue.
            </p>
          </div>
        </section>
        
        {/* AboutWhat component below the banner */}
        <AboutWhat />
        <ThermographyBenefits />
        <ConsultationSection />
      <FooterSection />
      </main>
    </>
  );
};

export default WhatBanner;
